import { render } from "./SystemUser.vue?vue&type=template&id=5de98670&scoped=true"
import script from "./SystemUser.vue?vue&type=script&lang=js"
export * from "./SystemUser.vue?vue&type=script&lang=js"

import "./SystemUser.vue?vue&type=style&index=0&id=5de98670&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de98670"]])

export default __exports__